export const trackEvent = (eventName, params = {}) => {
  try {
    if (!window.gtag) {
      console.warn('gtag no está cargado')
      return
    }

    window.gtag('event', eventName, params)
  } catch (error) {
    console.error('Error al enviar el evento a Google Analytics:', error)
  }
}
